import { Suspense } from "react";
import { useAuthenticatedContext } from "./AuthenticatedLayout";
import { APIKeysSection } from "./settings/APIKeysSection";
import { BillingSection } from "./settings/BillingSection";
import { InviteUserSection } from "./settings/InviteUserSection";
import { OrganizationMembersSection } from "./settings/OrganizationMembersSection";

function SettingsLoadingFallback() {
  return (
    <div className="text-muted-foreground animate-pulse pl-6">
      Loading settings...
    </div>
  );
}

export function SettingsPage() {
  const { currentOrgId, userId, organizationIds } = useAuthenticatedContext();

  return (
    <>
      <h1 className="text-3xl font-bold mb-6 pl-6">Settings</h1>

      <div className="space-y-6">
        {currentOrgId ? (
          <Suspense key={currentOrgId} fallback={<SettingsLoadingFallback />}>
            <APIKeysSection
              key={`api-keys-${currentOrgId}-${userId}`}
              organizationId={currentOrgId}
              currentUserId={userId}
            />
            <OrganizationMembersSection
              organizationId={currentOrgId}
              currentUserId={userId}
            />
            <InviteUserSection
              organizationId={currentOrgId}
              currentUserId={userId}
            />
            <BillingSection
              organizationId={currentOrgId}
              currentUserId={userId}
            />
          </Suspense>
        ) : organizationIds.length === 0 ? (
          <div className="text-muted-foreground">
            You are not a member of any organization yet.
          </div>
        ) : null}
      </div>
    </>
  );
}
